import "./styles.css";

import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/pro-solid-svg-icons";
import { faNewspaper } from "@fortawesome/pro-duotone-svg-icons";
import { useNavigate, useParams } from "react-router-dom";

import LoadingApp from "../../../../components/LoadingApp";
import ModalFeedBack from "../../../../components/ModalFeedBack";
import { useAccessibility } from "../../../../Store/contexts/AccessibilityContext";
import { getConteudo, getConteudoAnexo, getConteudoAnexos } from "../../../../services/SaudeBemEstar/ConteudosService";
import { Conteudo as ConteudoModel } from "../../../../interfaces/entities/SaudeBemEstar/Conteudos/Conteudo";
import { downloadBase64File } from "../../../../utils/DownloadFile";
import { ConteudoAnexo } from "../../../../interfaces/entities/SaudeBemEstar/Conteudos/ConteudoAnexo";
import AttachmentList from "../../../../components/AttachmentList";
import PageTitle from "../../../../components/Accessibility/PageTitle";

export default function Conteudo() {
  const [loading, setLoading] = React.useState(false);
  const [openErrorModal, setOpenErrorModal] = React.useState(false);
  const [conteudo, setConteudo] = React.useState<ConteudoModel | null>(null);
  const [anexos, setAnexos] = React.useState<ConteudoAnexo[]>([]);

  const accessibility = useAccessibility();
  const params = useParams();
  const navigate = useNavigate();

  const closeErrorModal = () => setOpenErrorModal(false);
  const downloadFile = (conteudoAnexo: ConteudoAnexo) => {
    setLoading(true);
    getConteudoAnexo(conteudoAnexo.idAnexo)
      .then((anexo) => {
        if (anexo?.anexo) downloadBase64File(anexo.anexo, anexo.descricaoCompleta);
        else setOpenErrorModal(true);
      })
      .catch(() => setOpenErrorModal(true))
      .finally(() => setLoading(false));
  };

  React.useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const conteudo = await getConteudo(params.id as string);
        setConteudo(conteudo);
  
        const anexos = await getConteudoAnexos(params.id as string);
        setAnexos(anexos);
      } catch (error) {
        setOpenErrorModal(true);
      } finally {
        setLoading(false);
      }
    };
  
    fetchData();
  }, [params.id]);

  const conteudoData = conteudo ? (
    <>
      <div style={{ color: accessibility.contrastMode ? accessibility.contrastColor : "" }} className="conteudo-icon-holder">
        <FontAwesomeIcon icon={faNewspaper} size="2xl" />
      </div>
      <PageTitle text={conteudo.titulo} />
      <div style={accessibility.textStyleAccessibility} className="conteudo-description" dangerouslySetInnerHTML={{ __html: conteudo.conteudo }} />
      {conteudo.indAnexo === "S" && (
        <AttachmentList attachments={anexos} onClick={downloadFile}/>
      )}
    </>
  ) : undefined;

  return (
    <>
      <div className="conteudo-content">
        {conteudoData}
        <button style={accessibility.textStyleAccessibility} className="back-button" onClick={() => navigate(-1)}>
          <FontAwesomeIcon style={accessibility.textStyleAccessibility} icon={faChevronLeft} />
          &nbsp;&nbsp;<u>Voltar</u>
        </button>
      </div>
      <LoadingApp showLoading={loading} />
      <ModalFeedBack
        showModal={openErrorModal}
        handleShowModal={closeErrorModal}
        handleButtonModal={closeErrorModal}
        icon="error"
        title="Erro"
        subTitle="Ocorreu um erro. Tente novamente em instantes."
        textButton="Fechar"
        showButtonModal
      />
    </>
  );
}
